<div class="container py-4">
  <div class="row">
    <div class="col-12">
      <div class="card shadow-sm border-0">
        <div class="card-header text-dark">
          <h4 class="mb-0">Booking Details</h4>
        </div>
        <div class="card-body">
          <!-- <div class="d-flex justify-content-end mb-4">
            <button
              class="btn btn-danger"
              (click)="openRefundModal()"
              *ngIf="booking?.status === 'refund_requested'"
            >
              Refund
            </button>
          </div> -->

          <div class="mb-4">
            <h5 class="section-title">
              <i class="fa fa-map-marker-alt text-success mr-2"></i> Spot
              Information
            </h5>
            <div class="row align-items-center">
              <div class="col-md-8">
                <p>
                  <strong>Title:</strong> {{ booking?.spotBookingId?.title }}
                </p>
                <p>
                  <strong>Address:</strong>
                  {{ booking?.spotBookingId?.address }}
                </p>
                <p>
                  <strong>Asset Type:</strong>
                  {{ booking?.spotBookingId?.assetType }}
                </p>
                <p>
                  <strong>Timing:</strong> {{ booking?.spotBookingId?.timing }}
                </p>
              </div>
              <div class="col-md-4 text-right">
                <img
                  *ngIf="booking?.spotBookingId?.beachImage"
                  [src]="booking?.spotBookingId?.beachImage"
                  alt="Spot Image"
                  class="img-fluid rounded shadow-sm"
                  style="max-height: 200px"
                />
              </div>
            </div>
          </div>

          <div class="mb-4">
            <h5 class="section-title">
              <i class="fa fa-calendar text-warning mr-2"></i> Booking
              Information
            </h5>
            <div class="row">
              <div class="col-md-6">
                <p><strong>Start Date : </strong> {{ booking?.startDate }}</p>
                <p><strong>End Date : </strong> {{ booking?.endDate }}</p>
                <p>
                  <strong>Slots : </strong> {{ booking?.slots?.join(", ") }}
                </p>
                <p>
                  <strong>Status : </strong>
                  <span
                    class="badge"
                    [ngClass]="{
                      'badge-success':
                        booking?.status === 'completed' ||
                        booking?.status === 'active',
                      'badge-danger':
                        booking?.status === 'cancelled' ||
                        booking?.status === 'expired',
                      'badge-warning':
                        booking?.status === 'pending' ||
                        booking?.status === 'cancel_requested' ||
                        booking?.status === 'refund_requested',
                      'badge-info': booking?.status === 'refunded'
                    }"
                  >
                    {{ booking?.status.split("_").join(" ") | titlecase }}
                  </span>
                </p>
              </div>
            </div>
          </div>

          <!-- Payment Info -->
          <div class="mb-4">
            <h5 class="section-title">
              <i class="fa fa-credit-card text-info mr-2"></i> Payment
              Information
            </h5>
            <div class="row">
              <div class="col-md-4">
                <p>
                  <strong>Amount:</strong> {{ booking?.currency }}
                  {{ booking?.chargeableAmount / 100 }}
                </p>
              </div>
              <div class="col-md-4">
                <p>
                  <strong>Without VAT:</strong>
                  {{ booking?.totalAmountWithoutVat }}
                </p>
              </div>
              <div class="col-md-4">
                <p>
                  <strong>VAT ({{ booking?.totalVatPercentage }}%):</strong>
                  {{ booking?.totalVatAmount }}
                </p>
              </div>
            </div>
          </div>

          <div class="mb-4">
            <h5 class="section-title">
              <i class="fa fa-user text-primary mr-2"></i> User Information
            </h5>
            <div class="row">
              <div class="col-md-6">
                <p><strong>Name:</strong> {{ booking?.user_id?.name }}</p>
                <p><strong>Email:</strong> {{ booking?.user_id?.email }}</p>
              </div>
              <div class="col-md-6">
                <p>
                  <strong>Username:</strong> {{ booking?.user_id?.username }}
                </p>
                <p>
                  <strong>Country:</strong>
                  {{ booking?.user_id?.countryObject?.countryName }}
                </p>
              </div>
            </div>
          </div>

          <div class="mb-4">
            <h5 class="section-title">
              <i class="fa fa-clock text-danger mr-2"></i> Slot Purchase Details
            </h5>
            <div class="table-responsive">
              <table class="table table-bordered table-striped">
                <thead class="thead-light">
                  <tr>
                    <th>Start</th>
                    <th>End</th>
                    <th>Slot</th>
                    <th>Amount</th>
                    <th>VAT</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor="let slot of booking?.spotBookingPurchaseSlotIds"
                    [ngClass]="{
                      'table-danger': slot?.refundStatus === 'completed'
                    }"
                  >
                    <td>{{ slot.startDateTime | date : "short" }}</td>
                    <td>{{ slot.endDateTime | date : "short" }}</td>
                    <td>{{ slot.slots }}</td>
                    <td>
                      {{ slot.currency }} {{ slot.chargeableAmount / 100 }}
                    </td>
                    <td>{{ slot.totalVatAmount }}</td>
                    <td>
                      <span
                        class="badge"
                        [ngClass]="{
                          'badge-success':
                            slot?.status === 'completed' ||
                            slot?.status === 'active',
                          'badge-danger':
                            slot?.status === 'cancelled' ||
                            slot?.status === 'expired',
                          'badge-warning':
                            slot?.status === 'pending' ||
                            slot?.status === 'cancel_requested' ||
                            slot?.status === 'refund_requested',
                          'badge-info': slot?.status === 'refunded'
                        }"
                      >
                        {{ slot?.status.split("_").join(" ") | titlecase }}
                      </span>
                    </td>
                    <td>
                      <!-- <button
                        class="btn btn-danger"
                        (click)="openCancelModal(slot._id)"
                        *ngIf="slot?.status === 'cancel_requested'"
                      >
                        Cancel Booking
                      </button> -->
                      <button
                        class="btn btn-danger"
                        (click)="openRefundModal(slot._id)"
                        *ngIf="slot?.status === 'cancelled'"
                      >
                        Refund
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #refundModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Refund Package</h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <form #refundForm="ngForm">
      <p>Would you like to refund full amount?</p>

      <!-- Radio -->
      <div class="form-group row">
        <div class="col-sm-8">
          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="radio"
              [(ngModel)]="detail.is_refund_full_amount"
              name="is_refund_full_amount"
              [value]="true"
            />
            <label class="form-check-label">Yes</label>
          </div>
          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="radio"
              [(ngModel)]="detail.is_refund_full_amount"
              name="is_refund_full_amount"
              [value]="false"
            />
            <label class="form-check-label">No</label>
          </div>
        </div>
      </div>

      <div
        *ngIf="detail.is_refund_full_amount === false"
        class="form-group row"
      >
        <label for="amountTotal" class="col-sm-4 col-form-label">
          Refund Amount ({{ booking.currency }})
        </label>
        <div class="col-sm-8">
          <input
            type="number"
            class="form-control"
            name="amountTotal"
            [(ngModel)]="detail.amountTotal"
            [max]="maxValue"
            required
          />
          <small
            class="form-text text-danger"
            *ngIf="refundForm.submitted && !detail.amountTotal"
          >
            Please enter valid fee (Max: {{ maxValue }} {{ currency }})
          </small>
        </div>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          (click)="modal.dismiss()"
        >
          Cancel
        </button>
        <button
          type="submit"
          class="btn btn-danger"
          [disabled]="getIsDisabled() || isLoading"
          (click)="submitRefund(refundForm)"
        >
          {{ isLoading ? "Refunding..." : "Submit" }}
        </button>
      </div>
    </form>
  </div>
</ng-template>
<ng-template #cancelRequestModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Cancel Request</h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>Are you sure you want to send a cancel request for this booking?</p>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-outline-secondary"
      (click)="modal.close('Close clicked')"
    >
      Cancel
    </button>
    <button
      type="button"
      class="btn btn-warning"
      (click)="confirmCancelRequest(cancelRequestId)"
      [disabled]="isCancelLoading"
    >
      {{ isCancelLoading ? "Sending..." : "Send Cancel Request" }}
    </button>
  </div>
</ng-template>
